import React from 'react';
import cx from 'classnames';

import {
  Button,
  Border,
  Dropzone,
  FileAction,
  Text,
  StepLabelList,
} from 'spindl-shared-components';
import CSVTable from '../../organisms/CSVTable';

import styles from './UploadCSV.module.scss';
import usePresenter from './UploadCSV.presenter';
import getProps from './UploadCSV.props';
import { UploadCSVCombinedProps } from './types';


const UploadCSV: React.FC<UploadCSVCombinedProps> = (props) => {
  const {
    state,
    className,
    classes,
    button,
    stepLabelList,
    border,
    label,
    instructions,
    dropzone,
    backButton,
    sendButton,
    reviewUsersLabel,
    fileAction,
    cSVTable,
    inviteEmailLabel,
    reviewUsersText,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`uploadCSV${variantName}`];


  let componentView;

  switch (variantName) {
    case 'Upload': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.topContent, classes?.topContent)}>
            <div className={cx(styles.header, classes?.header)}>
              <Button
                className={cx(styles.button, classes?.button)}
                {...internalProps.button}
                {...button}/>
            </div>
            <StepLabelList
              className={cx(styles.stepLabelList, classes?.stepLabelList)}
              {...internalProps.stepLabelList}
              {...stepLabelList}/>
            <Border
              className={cx(styles.border, classes?.border)}
              {...internalProps.border}
              {...border}/>
          </div>
          <div className={cx(styles.middleContent, classes?.middleContent)}>
            <Text
              className={cx(styles.label, classes?.label)}
              {...internalProps.label}
              {...label}/>
            <Text
              className={cx(styles.instructions, classes?.instructions)}
              {...internalProps.instructions}
              {...instructions}/>
            <Dropzone
              className={cx(styles.dropzone, classes?.dropzone)}
              {...internalProps.dropzone}
              {...dropzone}/>
          </div>
          <div className={cx(styles.bottomContent, classes?.bottomContent)}>
            <Button
              className={cx(styles.backButton, classes?.backButton)}
              {...internalProps.backButton}
              {...backButton}/>
            <Button
              className={cx(styles.sendButton, classes?.sendButton)}
              {...internalProps.sendButton}
              {...sendButton}/>
          </div>
        </div>
      );
      break;
    }
    case 'Uploaded': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.topContent, classes?.topContent)}>
            <div className={cx(styles.header, classes?.header)}>
              <Button
                className={cx(styles.button, classes?.button)}
                {...internalProps.button}
                {...button}/>
            </div>
            <StepLabelList
              className={cx(styles.stepLabelList, classes?.stepLabelList)}
              {...internalProps.stepLabelList}
              {...stepLabelList}/>
            <Border
              className={cx(styles.border, classes?.border)}
              {...internalProps.border}
              {...border}/>
          </div>
          <div className={cx(styles.middleContent, classes?.middleContent)}>
            <Text
              className={cx(styles.reviewUsersLabel, classes?.reviewUsersLabel)}
              {...internalProps.reviewUsersLabel}
              {...reviewUsersLabel}/>
            <FileAction
              className={cx(styles.fileAction, classes?.fileAction)}
              {...internalProps.fileAction}
              {...fileAction}/>
            <CSVTable
              className={cx(styles.cSVTable, classes?.cSVTable)}
              {...internalProps.cSVTable}
              {...cSVTable}/>
            <Text
              className={cx(styles.inviteEmailLabel, classes?.inviteEmailLabel)}
              {...internalProps.inviteEmailLabel}
              {...inviteEmailLabel}/>
            <Text
              className={cx(styles.reviewUsersText, classes?.reviewUsersText)}
              {...internalProps.reviewUsersText}
              {...reviewUsersText}/>
          </div>
          <div className={cx(styles.bottomContent, classes?.bottomContent)}>
            <Button
              className={cx(styles.backButton, classes?.backButton)}
              {...internalProps.backButton}
              {...backButton}/>
            <Button
              className={cx(styles.sendButton, classes?.sendButton)}
              {...internalProps.sendButton}
              {...sendButton}/>
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default UploadCSV;

